import Title from "components/Title";

export default function NotFound() {
  return (
    <>
      <Title title="Sorry, we didn't find what you're looking for." />
    </>
  );
}
